import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StockageService, environment } from '@perval/shared';
import { Subject, takeUntil } from 'rxjs';
import { OrganismeService } from '../../../organisme/services/organisme.service';
import { CognitoService, DrupalService } from '../../../shared';
import { SharedStateLegacyService } from '../../../shared/services/stockage/shared-state-legacy.service';
import { FeaturesEnum } from '../../../feature-flag/enums/feature.enum';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit, OnDestroy {
  protected readonly FeaturesEnum = FeaturesEnum;

  loading = false;
  email = '';
  password = '';
  showErrorMsg = false;
  showResetPasswordSuccessMsg = false;
  showValidateSuccessMsg = false;
  showSessionExpiredMsg = false;
  showDefaultErrorMsg = false;
  showUseIdnotErrorMsg = false;
  showOrganismExistErrorMsg = false;
  isPasswordDisplayed = false;
  resetPasswordInputType: 'password' | 'text' = 'password';

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly cognitoService: CognitoService,
    private readonly drupalService: DrupalService,
    private readonly organismeService: OrganismeService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly stockageService: StockageService,
    private readonly stockageLegacyService: SharedStateLegacyService,
  ) {}

  ngOnInit(): void {
    this.stockageService.clear();
    this.stockageLegacyService.clear();

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.initErrorMessages();

        if (params['message'] == 'reset-password') {
          this.showResetPasswordSuccessMsg = true;
        }
        if (params['message'] == 'validate') {
          this.showValidateSuccessMsg = true;
        }
        if (params['message'] == 'session-expired') {
          this.showSessionExpiredMsg = true;
        }
        if (params['message'] == 'use-idnot') {
          this.showUseIdnotErrorMsg = true;
        }
        if (params['message'] == 'organism-exist') {
          this.showOrganismExistErrorMsg = true;
        }
        if (params['message'] == 'default') {
          this.showDefaultErrorMsg = true;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isIdantifiantValid(): boolean {
    return (
      this.loginForm.controls.username.touched &&
      !this.loginForm.controls.username.valid
    );
  }

  public async signIn(): Promise<void> {
    this.loading = true;
    this.initErrorMessages();

    const { username, password } = this.loginForm.value as {
      username: string;
      password: string;
    };

    try {
      await this.cognitoService.signIn(username, password);
      await this.drupalService.createSession();
      this.organismeService.synchroOrganisme();
      window.location.href = `${environment.host}/content/accueil`;
    } catch {
      this.loading = false;
      this.showResetPasswordSuccessMsg = false;
      this.showValidateSuccessMsg = false;
      this.showSessionExpiredMsg = false;
      this.showErrorMsg = true;
    }
  }

  public async idNotSignIn(): Promise<void> {
    this.initErrorMessages();

    try {
      await this.cognitoService.idNotSignIn();
    } catch {
      this.loading = false;
      this.showErrorMsg = true;
    }
  }

  public showResetPassword(): void {
    this.isPasswordDisplayed = !this.isPasswordDisplayed;
    this.resetPasswordInputType = this.isPasswordDisplayed
      ? 'text'
      : 'password';
  }

  private initErrorMessages(): void {
    this.showResetPasswordSuccessMsg = false;
    this.showValidateSuccessMsg = false;
    this.showSessionExpiredMsg = false;
    this.showErrorMsg = false;
    this.showDefaultErrorMsg = false;
  }
}
